import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  gap: 9px;
  align-items: center;
  height: 21px;
`;
